/**
 * File: src/pages/admin-page.js
 * Mô tả: Trang Quản trị Cấu hình (/admin) yêu cầu xác thực Cloudflare Zero Trust & Popup Đăng nhập Admin bảo mật.
 * Liên quan: src/services/admin-auth-service.js, src/components/admin-login-modal.js, src/components/admin-config-editor.js
 */

import { createElement } from '../utils/dom.js';
import { getActiveConfigRevision } from '../services/admin-config-service.js';
import { isAdminAuthenticated, getAdminSession, logoutAdmin } from '../services/admin-auth-service.js';
import { renderAdminLoginModal } from '../components/admin-login-modal.js';
import { renderAdminGameSelector } from '../components/admin-game-selector.js';
import { renderAdminConfigEditor } from '../components/admin-config-editor.js';
import { renderAdminRevisionHistory } from '../components/admin-revision-history.js';

export const renderAdminPage = () => {
  const container = createElement('div', {
    className: 'admin-page-container',
    attributes: { style: 'padding-top: calc(72px + 2rem); padding-bottom: 4rem; position: relative;' },
  });

  const innerContainer = createElement('div', { className: 'container' });
  let selectedGameId = 'ant-clash';

  const renderContent = () => {
    innerContainer.innerHTML = '';

    // Nếu chưa xác thực -> Hiển thị Popup Đăng Nhập Admin
    if (!isAdminAuthenticated()) {
      const loginPopup = renderAdminLoginModal(() => renderContent());
      container.appendChild(loginPopup);
    }

    const session = getAdminSession();
    const activeRev = getActiveConfigRevision(selectedGameId);

    const headerEl = createElement('div', {
      className: 'admin-header',
      attributes: { style: 'margin-bottom: 1.5rem;' },
    });

    headerEl.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem; margin-bottom: 1.5rem;">
        <div>
          <h1 style="font-size: 2.25rem;">🔐 Cổng Quản Trị Cấu Hình SNT Games</h1>
          <p style="color: var(--color-text-muted);">
            Phiên đăng nhập: <strong style="color: var(--color-accent);">${session?.username || 'Admin'}</strong> • Bảo mật Serverless API
          </p>
        </div>
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div style="background: rgba(16, 185, 129, 0.15); border: 1px solid var(--color-success); padding: 8px 16px; border-radius: var(--radius-full); color: var(--color-success); font-size: 0.85rem; font-weight: 600;">
            🛡️ Cloudflare Zero Trust Protected
          </div>
          ${
            isAdminAuthenticated()
              ? `<button id="admin-logout-btn" class="btn btn-secondary" style="padding: 6px 14px; font-size: 0.85rem; color: var(--color-error); border-color: rgba(239,68,68,0.4);">🔴 Đăng Xuất</button>`
              : ''
          }
        </div>
      </div>
    `;

    const logoutBtn = headerEl.querySelector('#admin-logout-btn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', () => {
        logoutAdmin();
        renderContent();
      });
    }

    innerContainer.appendChild(headerEl);

    // Selector chọn game
    const selectorSection = renderAdminGameSelector(selectedGameId, (newGameId) => {
      selectedGameId = newGameId;
      renderContent();
    });
    innerContainer.appendChild(selectorSection);

    // Payload Preview
    const payloadPreviewEl = createElement('div', {
      attributes: { style: 'background: var(--bg-secondary); padding: 1.25rem; border-radius: var(--radius-lg); border: var(--border-glass); margin-bottom: 2rem;' },
    });
    payloadPreviewEl.innerHTML = `
      <h4 style="color: var(--color-accent); margin-bottom: 0.5rem;">Xem Trước Gói Mã Hóa Tĩnh (Encrypted Config Payload)</h4>
      <p style="font-size: 0.85rem; color: var(--color-text-muted); margin-bottom: 0.75rem;">Chuỗi mã hóa Base64 + XOR sẽ được Game Client tải trực tiếp từ <code>${activeRev.envelope.configUrl}</code>:</p>
      <div style="background: #000; padding: 0.75rem; border-radius: 6px; font-family: monospace; font-size: 0.75rem; color: #10b981; word-break: break-all;">
        ${activeRev.envelope.payload.substring(0, 160)}...
      </div>
    `;
    innerContainer.appendChild(payloadPreviewEl);

    // Editor & History
    const editorSection = renderAdminConfigEditor(selectedGameId, activeRev, () => renderContent());
    const historySection = renderAdminRevisionHistory(selectedGameId, () => renderContent());

    const grid = createElement('div', {
      attributes: { style: 'display: grid; grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); gap: 2rem;' },
    });

    grid.appendChild(editorSection);
    grid.appendChild(historySection);
    innerContainer.appendChild(grid);
  };

  renderContent();
  container.appendChild(innerContainer);
  return container;
};
